import * as React from "react";
import styled from "styled-components";
import { VismaCustomer } from ".";

interface Props {
  customers: VismaCustomer[];
}

const Table = styled.table`
  // Use all available width in all columns except the first one
  & thead tr {
    & > *:nth-child(1) {
      width: 150px;
    }
  }

  // Right align text in the first column
  & > * > tr > * {
    &:nth-child(1) {
      text-align: right;
      font-weight: bold;
      white-space: pre-wrap;
    }
  }
`;

const CustomerList = ({ customers }: Props) => {
  return (
    <div>
      {!customers.length && <p>Inga nya kunder hittades.</p>}
      {customers.map((customer) => (
        <div key={customer.customerNo}>
          <h4>{customer.name}</h4>
          <Table className="table-small dataTable dtr-inline">
            <thead>
              <tr>
                <th>Fält</th>
                <th>Värde</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Kundnr</td>
                <td>{customer.customerNo}</td>
              </tr>
              <tr>
                <td>Organisationsnummer</td>
                <td>{customer.organizationNumber}</td>
              </tr>
              <tr>
                <td>Namn</td>
                <td>{customer.name}</td>
              </tr>
              <tr>
                <td>Address 1</td>
                <td>{customer.address1}</td>
              </tr>
              <tr>
                <td>Address 2</td>
                <td>{customer.address2}</td>
              </tr>
              <tr>
                <td>Postnr</td>
                <td>{customer.zipCode}</td>
              </tr>
              <tr>
                <td>Ort</td>
                <td>{customer.town}</td>
              </tr>
              <tr>
                <td>Kontakttelefon</td>
                <td>{customer.contactPhone}</td>
              </tr>
              <tr>
                <td>Kontaktperson</td>
                <td>{customer.contactPerson}</td>
              </tr>
              <tr>
                <td>E-post</td>
                <td>{customer.email}</td>
              </tr>
              <tr>
                <td>Referens</td>
                <td>{customer.reference}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      ))}
    </div>
  );
};

export default CustomerList;
